import React from 'react';
import { auth as firebaseAuth } from '~/firebase/index';
import { Center, Icon, HStack, Image, useDisclosure, Spacer, Flex } from '@chakra-ui/react';
import { AiOutlineBell, AiOutlineMenu } from 'react-icons/ai';

import { useSetRecoilState, useRecoilValue } from 'recoil';
import mediaQueryStateAtom from '~/recoil/atom/mediaQueryState';
import authAtom from '~/recoil/atom/auth';
import isLoginModalOpenSelector from '~/recoil/selectors/isLoginModalOpen';
import isSearchItemModalOpenSelector from '~/recoil/selectors/isSearchItemModalOpen';

import ContentContainer from '~/container/Content';
import NavDrawer from './NavDrawer';
import NavBar from './NavBar';
import LocaleSelect from '../LocaleSelect';

import defaultLogo from '~/assets/images/logo.png';
import { storeLocaleSelector } from '~/recoil/selectors/storeLocale';

export default function Header() {
  const { isLargerThan768 } = useRecoilValue(mediaQueryStateAtom);

  const auth = useRecoilValue(authAtom);
  const store = useRecoilValue(storeLocaleSelector);
  const setLoginModalOpen = useSetRecoilState(isLoginModalOpenSelector);
  const setSearchItemModalOpen = useSetRecoilState(isSearchItemModalOpenSelector);

  const { isOpen, onClose, onOpen } = useDisclosure();

  const handleLogout = () => {
    if (auth) {
      firebaseAuth.signOut();
    }
  };

  if (!store) {
    return <></>;
  }

  const { logo } = store;

  return (
    <>
      <ContentContainer>
        <HStack h="50px" justify="center" w="full" px={{ base: 4, md: 0 }} py={1}>
          <Icon
            as={AiOutlineMenu}
            boxSize="1.75rem"
            opacity={isLargerThan768 ? 0 : 1}
            onClick={onOpen}
            position="absolute"
            left={3}
          />
          <Spacer flex={1} />
          <Image src={logo || defaultLogo} h="full" />
          <Flex flex={1} justifyContent="flex-end">
            <LocaleSelect />
          </Flex>
        </HStack>

        {isLargerThan768 ? (
          <NavBar
            isLogin={!!auth}
            onLoginModalOpen={() => {
              setLoginModalOpen(true);
            }}
            onLogout={handleLogout}
            onSearchModalOpen={() => setSearchItemModalOpen(true)}
          />
        ) : null}
      </ContentContainer>

      <NavDrawer
        isOpen={isOpen}
        onClose={onClose}
        isLogin={!!auth}
        onLoginModalOpen={() => {
          setLoginModalOpen(true);
        }}
        onLogout={handleLogout}
        onSearchModalOpen={() => setSearchItemModalOpen(true)}
      />
    </>
  );
}
